const directive = {
  noSymbol: {
    inserted: function(el) {
      // 加了个分号，不然用输入法会吞字
      const reg = /[^\u4E00-\u9FA5A-Za-z0-9\' ]/g;
      const input = el.getElementsByTagName("input")[0];

      input.onkeyup = function() {
        input.value = input.value.replace(reg, "");
        trigger(input, "input");
      };
      input.onblur = function() {
        const blurReg = /[^\u4E00-\u9FA5A-Za-z0-9]/g;
        input.value = input.value.replace(blurReg, "");
        trigger(input, "input");
      };
    }
  },
  copy: {
    bind(el, { value }) {
      el.$value = value;
      el.handler = () => {
        if (!el.$value) {
          return;
        }
        const textarea = document.createElement("textarea");
        textarea.readOnly = true;
        textarea.style.position = "absolute";
        textarea.style.left = "-9999px";
        textarea.value = el.$value;
        document.body.appendChild(textarea);
        textarea.select();
        const result = document.execCommand("Copy");
        if (result) {
          $vue.$message.success("复制成功");
        }
        document.body.removeChild(textarea);
      };
      el.addEventListener("click", el.handler);
    },
    componentUpdated(el, { value }) {
      el.$value = value;
    },
    unbind(el) {
      el.removeEventListener("click", el.handler);
    }
  }
};

const replaceCharacters = inputString => {
  const regex = /[^\u4E00-\u9FA5A-Za-z0-9]/g;
  return inputString.replace(regex, "");
};

const trigger = (el, type) => {
  const e = document.createEvent("HTMLEvents");
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
};

export default {
  install: function(Vue) {
    Object.keys(directive).forEach(key => {
      Vue.directive(key, directive[key]);
    });
  }
};



// WEBPACK FOOTER //
// ./src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/utils/directive.js